import React from 'react';
import type { ReactElement } from 'react';
import type { SelectOption } from '@construct-kit/core';
import { Select, spacingHelper } from '@construct-kit/core';
import styled, { css } from 'styled-components';
import { FilterWrapper } from './FilterWrapper';

export type NabersEnergyRatingFilterProps = {
  options: SelectOption[];
  value: SelectOption;
  onChange: (newValue: SelectOption) => void;
};

const StyledSelect = styled(Select)`
  margin-top: ${spacingHelper('medium')};
  width: 100%;
  ${({ theme }) => css`
    ${theme.layoutBreakpoints.large} {
      width: 50%;
    }
  `}
`;
export const NabersEnergyRatingFilter = ({
  options,
  value,
  onChange,
}: NabersEnergyRatingFilterProps): ReactElement => (
  <FilterWrapper title="NABERS Energy Rating">
    <StyledSelect
      label=""
      hideLabel
      selectedOption={value}
      options={options}
      onSelectedOptionChange={(selectedOption?: SelectOption | null): void => {
        if (selectedOption) onChange(selectedOption);
      }}
    />
  </FilterWrapper>
);
